exports.list = {
    path: '/laporan_pemakaian_consumable',
    name: 'laporan_pemakaian_consumable_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_pemakaian_consumable/List.vue"),
}